import script from "./OAuthLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthLogin.vue?vue&type=script&setup=true&lang=js"

import "./OAuthLogin.vue?vue&type=style&index=0&id=a51b78f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a51b78f2"]])

export default __exports__